import { ExpandMore } from '@material-ui/icons';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Divider,
} from '@material-ui/core';
import { useState } from 'react';
import { observer } from 'mobx-react';
import { TitleDivider } from '../common/titleDivider';
import { FeesDetailsTableTerm } from './feesDetailsTableTerm';
import { FeesDetailsTable } from './feesDetailsTable';
import { isBridgeLoan } from '../../utils/utils';
import { IQuoteTypeStore } from '../../stores/common/iQuoteTypeStore';

interface PointsAndFeesDetailsAccordionProps {
  store: IQuoteTypeStore;
}

export const PointsAndFeesDetailsAccordion = observer(
  ({ store }: PointsAndFeesDetailsAccordionProps) => {
    const [expanded, setExpanded] = useState(false);
    const isTermLoan = !isBridgeLoan(store.loanSubtype);
    return (
      <Accordion
        expanded={expanded}
        onChange={(e, expanded) => setExpanded(expanded)}
        elevation={0}
      >
        <AccordionSummary
          expandIcon={<ExpandMore fontSize="large" />}
          aria-controls={`economics-summary-accordion`}
        >
          <Grid item xs={12}>
            <TitleDivider title={'Points & Fee Details'} />
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          {isTermLoan ? (
            <FeesDetailsTableTerm store={store} />
          ) : (
            <FeesDetailsTable store={store} />
          )}
        </AccordionDetails>
      </Accordion>
    );
  }
);
